module.exports = __webpack_public_path__ + "img/index01.68cfc91b.webp";